import axios from 'axios'
import Utils from '../../../utils/utils'
import CONST from '../../../utils/const'
import config from '../../../config'

export async function getPeculiarSmell(condition = {}) {
  let response = {}
  try {
    response = await axios.get(`${config.eastCoastDataApi()}BaseData/PeculiarSmellDetector`)

  } catch (err) {
    console.error('iisi getPeculiarSmell: ', err)
    return null
  }

  return response.data
}